<template>
  <div id="table-list">
    <v-table class="web-view" ref="web-view">
      <thead class="table-header">
        <tr>
          <th
            v-for="(header, index) in headerList"
            :key="index"
            :class="header.textAlign"
            class="header-text"
          >
            {{ header.title }}
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        <template v-if="userList.length > 0">
          <tr v-for="(user, index) in userList" :key="index">
            <td
              v-for="(header, headerIndex) in headerList"
              :key="headerIndex"
              class="body-text"
            >
              <div
                v-if="
                  ![
                    'actions',
                    'active',
                    'logo',
                    'cover_image',
                    'partner',
                    'role',
                    'gps',
                    'address',
                  ].includes(header.value)
                "
              >
                {{ user[seenAttrs[headerIndex]] }}
              </div>
              <div v-else-if="header.value == 'logo'" class="logo">
                <img v-if="user.logo_base64" :src="user.logo_base64" />
                <v-icon v-else icon="mdi-image-off-outline"></v-icon>
              </div>
              <div v-else-if="header.value == 'cover_image'" class="logo">
                <img
                  v-if="user.cover_image_base64"
                  :src="user.cover_image_base64"
                />
                <v-icon v-else icon="mdi-image-off-outline"></v-icon>
              </div>
              <div v-else-if="header.value == 'partner'">
                {{ user.partner && user.partner.par_name }}
              </div>
              <div v-else-if="header.value == 'address'">
                {{ getAddress(user) }}
              </div>
              <div v-else-if="header.value == 'active'">
                {{ getActiveString(user[seenAttrs[headerIndex]]) }}
              </div>
              <div v-else-if="header.value == 'role'">
                {{ getRoleString(user[seenAttrs[headerIndex]]) }}
              </div>
              <div v-else-if="header.value == 'gps'">
                {{ getCoordinates(user[seenAttrs[headerIndex]]) }}
              </div>
              <div v-else class="actions">
                <template v-if="this.userType !== 'partners'">
                  <v-btn
                    @click="handleEditButton(user, index)"
                    icon="mdi-pencil"
                    variant="text"
                  ></v-btn>
                </template>
                <template v-else>
                  <v-btn
                    :id="`menu-activator-${index}`"
                    icon="mdi-pencil"
                    variant="text"
                  ></v-btn>
                  <v-menu :activator="`#menu-activator-${index}`">
                    <v-list>
                      <v-list-item
                        v-for="(item, listIndex) in menuItems"
                        :key="listIndex"
                        :value="listIndex"
                        :append-icon="item.icon"
                        @click="item.action(user, index)"
                      >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </v-table>
    <v-table class="mobile-view" ref="mobile-view">
      <div
        class="container"
        :class="index == userList.length - 1 ? 'last' : ''"
        v-for="(user, index) in userList"
        :key="index"
      >
        <div
          class="mobile-item"
          v-for="(header, headerIndex) in headerList"
          :key="headerIndex"
        >
          <div class="left-side">{{ header.title }}</div>
          <div
            v-if="
              !['actions', 'active', 'logo', 'partner', 'role'].includes(
                header.value
              )
            "
            class="right-side"
          >
            {{ user[seenAttrs[headerIndex]] }}
          </div>
          <div v-else-if="header.value == 'logo'" class="logo">
            <img v-if="user.logo_base64" :src="user.logo_base64" />
          </div>
          <div v-else-if="header.value == 'partner'">
            {{ user.partner && user.partner.par_name }}
          </div>
          <div v-else-if="header.value == 'active'">
            {{ getActiveString(user[seenAttrs[headerIndex]]) }}
          </div>
          <div v-else-if="header.value == 'role'">
            {{ getRoleString(user[seenAttrs[headerIndex]]) }}
          </div>
          <div v-else class="right-side actions">
            <template v-if="this.userType !== 'partners'">
              <v-btn
                @click="handleEditButton(user, index)"
                icon="mdi-pencil"
                variant="text"
              ></v-btn>
            </template>
            <template v-else>
              <v-btn
                :id="`menu-activator-mobile-${index}`"
                icon="mdi-pencil"
                variant="text"
              ></v-btn>
              <v-menu :activator="`#menu-activator-mobile-${index}`">
                <v-list>
                  <v-list-item
                    v-for="(item, listIndex) in menuItems"
                    :key="listIndex"
                    :value="listIndex"
                    :append-icon="item.icon"
                    @click="item.action(user, index)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </div>
        </div>
      </div>
    </v-table>
    <div
      v-if="userList.length <= 0"
      class="d-table w-100 text-center mx-auto"
      justify="center"
    >
      <v-sheet class="flex-1-1-100">
        <Vue3Lottie :animationData="NoDataLottie" :height="200" :width="200" />
        <div class="pb-5 table-no-data">
          <h3>{{ $t("tableNoDataTitle") }}</h3>
          <p>{{ $t("tableNoDataDesc") }}</p>
        </div>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";
import EditUserModal from "@/components/global/modalComponents/EditUserModal/EditUserModal";
import EditConductorModal from "@/components/global/modalComponents/EditUserModal/EditConductorModal";
import EditPartnerPopper from "@/components/global/popperComponents/EditPartnerPopper/EditPartnerPopper";
import SettingsPartnerPopper from "@/components/global/popperComponents/EditPartnerPopper/SettingsPartnerPopper";
import { activeEnums } from "@/components/enums";
import { roleEnums } from "@/components/enums";
import EditWebhsopUserTypeModal from "../modalComponents/EditUserModal/EditWebhsopUserTypeModal.vue";
import EditcapacitySettingsModal from "@/components/global/modalComponents/EditcapacitySettingsModal/EditcapacitySettingsModal";

export default {
  name: "TableList",
  props: {
    userList: {
      type: Array,
      required: true,
    },
    seenAttrs: {
      type: Array,
      required: true,
    },
    headerList: {
      type: Array,
      required: true,
    },
    itemActionList: {
      type: Array,
      default: () => [],
    },
    userType: {
      type: String,
      default: "",
    },
  },
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      menuItems: [
        {
          type: "editLayout",
          icon: "mdi-pencil",
          title: this.$t("partners.table.actions.edit"),
          action: (user, index) => this.handleEditButton(user, index),
        },
        {
          type: "settingsLayout",
          icon: "mdi-cog-outline",
          title: this.$t("partners.table.actions.settings"),
          action: (user, index) => this.handleSettingsButton(user, index),
        },
      ],
    };
  },
  mounted() {},
  methods: {
    getRoleString(value) {
      return value === 0
        ? this.$t("enums.role.superAdmin")
        : this.$t("enums.role.admin");
    },
    getActiveString(value) {
      return value === true
        ? this.$t("enums.activity.active")
        : this.$t("enums.activity.inactive");
    },
    getCoordinates(gps) {
      if (gps) {
        return `${gps.coordinates[0]} ${gps.coordinates[1]}`;
      }
    },
    getAddress(user) {
      return `${user.par_zip_code} ${user.par_city} ${user.par_public_space_name} ${user.par_house_number}`;
    },
    handleButtonClick(type, user) {
      this.emitter.emit("buttonClicked", {
        type,
        user: JSON.parse(JSON.stringify(user)),
      });
    },
    handleEditButton(currentUser, index) {
      if (this.userType != "partners") {
        this.emitter.emit("showComponentModalModal", {
          bind: {
            is:
              this.userType == "conductors"
                ? EditConductorModal
                : this.userType == "webshopUserType"
                ? EditWebhsopUserTypeModal
                : this.userType == "capacitySettings"
                ? EditcapacitySettingsModal
                : EditUserModal,
            user: currentUser,
          },
          on: {
            saveUser: (user) => {
              this.$emit("userChanged", user, index);
            },
            userDelete: (user) => {
              this.$emit("userDelete", user, index);
            },
          },
        });
      } else {
        this.emitter.emit("showPopper", {
          bind: {
            is: EditPartnerPopper,
            headerTitle: this.$t("editPartnerPopperComponent.title.edit"),
            user: currentUser,
          },
          on: {
            saveUser: (user) => {
              this.$emit("userChanged", user, index);
            },
            userDelete: (user) => {
              this.$emit("userDelete", user, index);
            },
          },
        });
      }
    },
    handleSettingsButton(currentUser) {
      this.emitter.emit("showPopper", {
        bind: {
          is: SettingsPartnerPopper,
          headerTitle: this.$t("settingsPartnerPopperComponent.title.edit"),
          user: currentUser,
        },
      });
    },
  },
  computed: {
    activeEnums() {
      return activeEnums;
    },
    roleEnums() {
      return roleEnums;
    },
  },
};
</script>

<style lang="scss" scoped>
#table-list {
  .web-view {
    @media (max-width: 1020px) {
      display: none;
    }
    .table-header {
      .header-text {
        font-size: 14px;
        font-weight: 600;
        color: #000000de;
      }
    }
    .table-body {
      .body-text {
        font-size: 14px;
        font-weight: 400;
        color: #000000de;
        .logo i {
          color: #e1e0e0;
          font-size: 30px;
        }
        .cover-image i {
          color: #e1e0e0;
          font-size: 30px;
        }
      }
      .actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 32px;
        }
      }
      .cover-image {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 32px;
        }
      }
    }
  }
  .mobile-view {
    @media (min-width: 1021px) {
      display: none;
    }

    .container {
      padding: 16px 0;
      border-bottom: thin solid rgba(0, 0, 0, 0.12);

      &.last {
        border-bottom: 0;
      }

      .mobile-item {
        display: flex;
        justify-content: space-between;
        padding: 8px 4px;
        .left-side {
          font-weight: 600;
        }
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 32px;
          }
        }
        .cover-image {
          display: flex;
          align-items: center;
          img {
            width: 32px;
          }
        }
      }
    }
  }
}
</style>
